import React from 'react';
import {Redirect} from 'react-router-dom';
import resolvePath from '../../misc/resolvePath';
import ErrorBoundary from './ErrorBoundary';

const RedirectOnError = props => {
    const {to = '..'} = props,
        altComponent = <Redirect to={resolvePath(app.history.location.pathname, to)} />;

    return <ErrorBoundary altComponent={altComponent}>{props.children}</ErrorBoundary>;
};

export default RedirectOnError;
